export enum SCORE_TYPE {
  GOOD = 'good',
  OKAY = 'okay',
  IMPROVE = 'improve',
}
